import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgPalmTreeGlyphSecondary from './svgs/PalmTreeGlyphSecondary.js';
import SvgPalmTreeGlyph from './svgs/PalmTreeGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var palmTreeGlyph = (props => useIcon(SvgPalmTreeGlyph, SvgPalmTreeGlyphSecondary, props));

export { palmTreeGlyph as default };
